module.exports = __webpack_public_path__ + "img/more-packages.498fc6f0.webp";